import React from 'react';
import PropTypes from 'prop-types';
import AirportDateTimePickers from 'common/airport/AirportDateTimePickers';

const ParkingDateTimePanel = ({
    starts,
    ends,
    isFetchingRates,
    onSearchClick
}) => {
    return (
        <div className="ParkingDateTimePanel">
            <AirportDateTimePickers
                startLabel="Parking Check In"
                endLabel="Parking Check Out"
                starts={starts}
                ends={ends}
                isLoading={isFetchingRates}
                searchButtonText="Check Availability"
                onSearchClick={onSearchClick}
            />
        </div>
    );
};

ParkingDateTimePanel.propTypes = {
    isFetchingRates: PropTypes.bool,
    starts: PropTypes.string,
    ends: PropTypes.string,
    onSearchClick: PropTypes.func.isRequired
};

export default ParkingDateTimePanel;
